// CostosTabXL - Sprint 44 Fase 3 Vista 10.
// Flete/Aduana/Broker/Otros con XLMoneyInput + selector moneda + bloque TRM.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLMoneyInput from '../../../components/xl/XLMoneyInput';
import XLSelect from '../../../components/xl/XLSelect';
import XLInput from '../../../components/xl/XLInput';
import { MONEDA_OPTIONS } from '../utils';

const CSS_ID = 'xl-imp-costos-css';
const CSS = `
.xl-cost { display: flex; flex-direction: column; gap: 20px; font-family: var(--xl-font-sans) }
.xl-cost__grid {
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px;
}
@media (max-width: 720px) { .xl-cost__grid { grid-template-columns: 1fr } }
.xl-cost__pair { display: flex; gap: 8px; align-items: end }
.xl-cost__pair-money { flex: 1 }
.xl-cost__pair-mon { width: 100px }

.xl-cost__trm-section {
  border-top: 1px solid var(--xl-color-border);
  padding-top: 16px;
}
.xl-cost__trm-title {
  font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--xl-color-text-muted); margin-bottom: 10px;
}
.xl-cost__trm-row { display: flex; gap: 8px; align-items: end }
.xl-cost__trm-row > .xl-cost__trm-row-input { flex: 1 }
.xl-cost__btn-auto {
  font: 500 12px/1 var(--xl-font-sans); padding: 9px 12px;
  border-radius: var(--xl-radius-md);
  border: 1px solid var(--xl-color-border);
  background: var(--xl-color-bg); color: var(--xl-color-text-secondary);
  cursor: pointer; white-space: nowrap;
}
.xl-cost__btn-auto:hover { background: var(--xl-color-surface-alt); color: var(--xl-color-text) }
.xl-cost__btn-auto:focus-visible { outline: 2px solid var(--xl-color-focus); outline-offset: 2px }
.xl-cost__trm-fecha {
  font-size: 11px; color: var(--xl-color-text-muted); margin-top: 4px;
}
`;

function CostoPair({ label, valor, moneda, onValor, onMoneda }) {
  return (
    <div className="xl-cost__pair">
      <div className="xl-cost__pair-money">
        <XLMoneyInput label={label} value={valor} onChange={onValor} />
      </div>
      <div className="xl-cost__pair-mon">
        <XLSelect label="Moneda" value={moneda}
          onChange={(e) => onMoneda(e.target.value)}
          options={MONEDA_OPTIONS} />
      </div>
    </div>
  );
}

function TrmField({ label, valor, fecha, onValor, onAuto }) {
  return (
    <div>
      <div className="xl-cost__trm-row">
        <div className="xl-cost__trm-row-input">
          <XLInput label={label} type="number" min="0" step="0.01"
            value={valor == null ? '' : valor}
            onChange={(e) => onValor(e.target.value)} />
        </div>
        <button type="button" className="xl-cost__btn-auto" onClick={onAuto}>
          auto
        </button>
      </div>
      <div className="xl-cost__trm-fecha">Fecha: {fecha || '\u2014'}</div>
    </div>
  );
}

export default function CostosTabXL({
  form, set, onTrmToday, onTrmViernes, showTrm, tipo,
}) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  const showFlete = tipo !== 'nacionalizada';

  return (
    <div className="xl-cost">
      <div className="xl-cost__grid">
        {showFlete && (
          <CostoPair label="Flete"
            valor={form.flete} moneda={form.flete_moneda}
            onValor={(n) => set('flete', n == null ? '' : n)}
            onMoneda={(v) => set('flete_moneda', v)} />
        )}
        <CostoPair label="Aduana"
          valor={form.aduana} moneda={form.aduana_moneda}
          onValor={(n) => set('aduana', n == null ? '' : n)}
          onMoneda={(v) => set('aduana_moneda', v)} />
        <CostoPair label="Broker"
          valor={form.broker} moneda={form.broker_moneda}
          onValor={(n) => set('broker', n == null ? '' : n)}
          onMoneda={(v) => set('broker_moneda', v)} />
        <CostoPair label="Otros"
          valor={form.otros} moneda={form.otros_moneda}
          onValor={(n) => set('otros', n == null ? '' : n)}
          onMoneda={(v) => set('otros_moneda', v)} />
      </div>

      {showTrm && (
        <div className="xl-cost__trm-section">
          <div className="xl-cost__trm-title">TRM</div>
          <div className="xl-cost__grid">
            <TrmField label="TRM financiera"
              valor={form.trm_financiera} fecha={form.trm_financiera_fecha}
              onValor={(v) => set('trm_financiera', v)}
              onAuto={onTrmToday} />
            <TrmField label="TRM aduanera (viernes anterior al arribo)"
              valor={form.trm_aduanera} fecha={form.trm_aduanera_fecha}
              onValor={(v) => set('trm_aduanera', v)}
              onAuto={onTrmViernes} />
            <XLInput label="TRM manual (override opcional)"
              type="number" min="0" step="0.01"
              value={form.trm_manual == null ? '' : form.trm_manual}
              onChange={(e) => set('trm_manual', e.target.value)} />
          </div>
        </div>
      )}
    </div>
  );
}
